import React from 'react';
import { Layout, Input } from 'antd';
import '../styles/AdminHeader.css';

const { Header } = Layout;
const { Search } = Input;

const AdminHeader = () => {
  const onSearch = (value) => console.log(value);

  return (
    <Header className="header">
      <div className="logo">
        
      </div>
      <div className="search-bar">
        <Search
          placeholder="Search..."
          onSearch={onSearch}
          style={{ width: 200 }}
        />
      </div>
    </Header>
  );
};

export default AdminHeader;
